import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import {
  DashCardHeader,
  type DashCardHeaderProps,
} from 'legacy/dash-blocks/dash-card/components/DashCardHeader'
import { dashColors } from 'legacy/dash-blocks/foundation/colors'
import { dashFontSizes } from 'legacy/dash-blocks/foundation/typography'
import { type BoxProps, Box } from 'legacy/dash-blocks/box/Box'
import { type DashBoxShadow, dashBoxShadowMapping } from 'legacy/dash-blocks/foundation/styling'
import { dashPixels } from 'legacy/dash-blocks/foundation/spacing-units/spacingUnits.types'

interface CardWrapperProps {
  scrollable: boolean
  shadow: DashBoxShadow
  hideBorder: boolean
}

const DashCardWrapper = styled(Box)<CardWrapperProps>`
  background-color: ${dashColors.WHITE};
  border-radius: ${dashPixels.PX4};
  transition: 0.2s box-shadow;
  overflow-y: hidden;
  overflow-x: ${({ scrollable }) => (scrollable ? 'hidden' : 'auto')};
  box-shadow: ${({ shadow }) => dashBoxShadowMapping[shadow]};

  ${({ hideBorder }) => !hideBorder && `border: 1px solid ${dashColors.NEUTRAL};`}
`

const CardBody = styled(Box)`
  font-size: ${dashFontSizes.MEDIUM};
`

export type DashCardProps = DashCardHeaderProps & BoxProps & Partial<CardWrapperProps> & {}

export const DashCard: FunctionComponent<DashCardProps> = ({
  header,
  children,
  shadow = 'none',
  scrollable = false,
  hideBorder = false,
  ...rest
}) => (
  <DashCardWrapper shadow={shadow} scrollable={scrollable} hideBorder={hideBorder} {...rest}>
    <DashCardHeader header={header} />
    <CardBody padding="small">{children}</CardBody>
  </DashCardWrapper>
)
